<template>
  <div>
    <div class="pro-data">
      <div class="data-th">
        <div class="th-div">排名</div>
        <div class="th-div">姓名</div>
        <div v-if="link=='members'" class="th-div">成员数量</div>
        <div v-if="link=='income'" class="th-div">进件数量</div>
        <div v-if="link=='achievement'" class="th-div">金额（元）</div>
        <div class="th-div">环比</div>
      </div>
      <div class="data-td">
        <div class="td-div-box" v-for="(item,index) in dataList" :key="index">
          <div class="td-div" v-if="(index+1)==1">
            <img src="@/assets/publicImg/icon1.png" alt />
          </div>
          <div class="td-div" v-else-if="(index+1)==2">
            <img src="@/assets/publicImg/icon2.png" alt />
          </div>
          <div class="td-div" v-else-if="(index+1)==3">
            <img src="@/assets/publicImg/icon3.png" alt />
          </div>
          <div class="td-div" v-else>{{index+1}}</div>
          <div class="td-div">{{item.username}}</div>
          <div class="td-div">{{item.numOfPeople}}</div>
          <div class="td-div">{{item.chain}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URLTB from "@/api/apiTB";
export default {
  props: ['link', 'link2'],
  watch: {
    link: {
      handler(newValue, oldValue) {
      },
      immediate: true
    },
    link2: {
      handler(newValue, oldValue) {
      },
      immediate: true
    }
  },
  data() {
    return {
      dataList: [],
    }
  },
  methods:{
    getData(link,link2) {
      let data = {
        userId: localStorage.getItem('userid'),
        dataType: link,
        monthType: link2
      }
      this.$fetchGet(URLTB.teamRanking.url, data).then(res => {
        // console.log(res.data.data);/
        this.dataList=res.data.data
      })
    },
  }
}
</script>

<style lang="less" scoped>
.pro-data {
  width: 355px;
  height: 369px;
  margin: auto;
  font-family: Source Han Sans CN;
  font-weight: Medium;
  .data-th {
    width: 355px;
    height: 33px;
    line-height: 33px;
    background: url("../../assets/publicImg/ranking-bg.png") no-repeat 100%;
    display: flex;
    justify-content: space-around;
    text-align: center;
    font-size: 13px;
    color: #ffffff;
    .th-div {
      width: 70px;
      &:first-child {
        width: 45px;
      }
      &:nth-child(2){
        width: 100px;
      }
    }
  }
  .data-td::-webkit-scrollbar {
    display: none;
  }
  .data-td {
    width: 355px;
    height: calc(100vh - 150px);
    overflow-y: scroll;
  }
  .td-div-box {
    height: 30px;
    // line-height: 30px;
    align-items: center;
    display: flex;
    justify-content: space-around;
    text-align: center;
    font-family: DIN;
    font-size: 9px;
    color: #333333;
    &:nth-child(2n + 1) {
      background: #fff8ea;
    }
    &:nth-child(2n) {
      background: url("../../assets/publicImg/ranking-bg1.png") no-repeat 50%;
      background-size: 100% 100%;
    }
    &:not(:first-child) {
      margin-top: 3px;
    }
    .td-div {
      width: 70px;
      &:first-child {
        width: 45px;
        font-weight: bold;
      }
      &:nth-child(2){
        width: 100px;
      }
      img {
        width: 13px;
        height: 18px;
        margin-top: 6px;
      }
    }
  }
}
</style>